import globalFeatureFlags from "../../globalFeaturesFlags";
import globalUrls from "../../globalUrls";

// Map specific URLs to Naturimal feature flags that control them.
// If a URL is not present here, it is always enabled (fallback behavior).
export const featureFlagToUrls: Record<string, string[]> = {
  [globalFeatureFlags.EVENTS]: [globalUrls.SPECIAL_EVENTS],
  [globalFeatureFlags.BLOG]: [globalUrls.BLOG, globalUrls.BLOG_POST],
  [globalFeatureFlags.PRODUCTS_ZONE]: [globalUrls.ONLINE_STORE_SELECT_DISTRITO],
  [globalFeatureFlags.ONLINE_STORE]: [globalUrls.ONLINE_STORE],
  [globalFeatureFlags.APPOINTMENTS]: [globalUrls.APPOINTMENTS, globalUrls.SERVICES_PUBLIC, globalUrls.PUBLIC_CALENDAR],
};

// Helper: given a URL path from globalUrls, find the controlling feature flag name, if any.
export function findFeatureFlagForUrl(path: string): string | null {
  for (const [featureName, urls] of Object.entries(featureFlagToUrls)) {
    if (urls.includes(path)) {
      return featureName;
    }
  }
  return null;
}
